import "../ktt-window.js";
import { API_BASE } from "../shared/ktt-host.js";

async function readServerFile(path) {
  const response = await fetch(path, {
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error("Failed to load file from server");
  }

  const result = await response.text();
  return result.match(window.regExes.lines);
}

const loadFiles = async () => {
  const tempFiles = {
    configFile: undefined,
    goalsFile: undefined,
    logSource: undefined,
  };

  if (import.meta.env.localserver) {
    console.info("localserver");

    tempFiles.configFile = await readServerFile(API_BASE + "/config-file");
    tempFiles.goalsFile = await readServerFile(API_BASE + "/goals-file");
    tempFiles.logSource = await readServerFile(API_BASE + "/log-source");

    if (tempFiles.logSource != undefined) {
      return tempFiles;
    }
  } else {
    // Read initial CSV data
    async function readFile(path) {
      const file = new XMLHttpRequest();
      let data;
      file.onreadystatechange = () => {
        if (file.readyState === 4) {
          if (file.status === 200 || file.status == 0) {
            data = file.responseText;
          }
        }
      };
      file.open("GET", path, false);
      file.overrideMimeType("text/html");
      file.send(null);
      return data.match(window.regExes.lines);
    }

    tempFiles.logSource = readFile(window.config.files.logPath);

    if (tempFiles.logSource) {
      tempFiles.configFile = readFile(window.config.files.configPath);
      tempFiles.goalsFile = readFile(window.config.files.goalsPath);
      return tempFiles;
    }

    console.info("not localserver");
    return null;
  }
};

export const logsReady = () => loadFiles();
